"use client";

import { Product } from "src/lib/fetcher/client";
import SalifyFallback from "../../salify-fallback/default";
import { H3 } from "../../salify-next-layout/default/components/Typography";

const ProductDescription = ({ product }: { product: Product }) => {
  return (
    <div>
      <SalifyFallback.Label
        path="Product Description Heading"
        default="Chi tiết"
        render={(value) => <H3 mb={2}>{value}</H3>}
      />
      <div dangerouslySetInnerHTML={{ __html: product?.description }} />
    </div>
  );
};

export default ProductDescription;
